import type { CSSProperties, ReactElement } from "react";
import { color, layout, radius, space } from "@tokens/index";
import { Avatar, Text } from "@primitives/index";
import type { TimelineEventWorkItem } from "../../../experience-shell/workflows/timeline";

const authorRowStyle: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: space[2],
  marginBottom: space[1],
  minWidth: 0,
};

/**
 * Textual content of a work item under its headline. Messages read as a
 * flat tonal bubble; tasks and notes read as a quoted first line.
 */
export function WorkItemBody({
  workItem,
}: {
  readonly workItem: TimelineEventWorkItem;
}): ReactElement {
  const isMessage = workItem.type === "message";
  const author = workItem.createdByDisplayName;
  return (
    <div
      style={{
        marginTop: space[1],
        paddingInline: space[3],
        paddingBlock: space[2],
        borderRadius: radius.md,
        background: isMessage ? color.bg.surface2 : "transparent",
        borderLeft: isMessage ? "none" : `2px solid ${color.border.subtle}`,
        maxWidth: layout.proseMaxWidth,
        minWidth: 0,
      }}
    >
      {isMessage && author !== null && author !== undefined && author.length > 0 ? (
        <div style={authorRowStyle}>
          <Avatar alt={author} size="xs" />
          <Text role="bodySm" weight="semibold" truncate>
            {author}
          </Text>
        </div>
      ) : null}
      <Text
        role="body"
        style={{
          display: "block",
          whiteSpace: "pre-wrap",
          overflowWrap: "anywhere",
          color: color.fg.default,
        }}
      >
        {workItem.body}
      </Text>
    </div>
  );
}
